import { render, staticRenderFns } from "./extrato-dirigentes-table.vue?vue&type=template&id=0954fff5"
import script from "./extrato-dirigentes-table.vue?vue&type=script&lang=js"
export * from "./extrato-dirigentes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports